// 0 待审核 1通过 3 未通过  4 删除
const WORK_STATUS_TEXT = [
  '待审核', // 0
  '审核通过', // 1
  '已下架', // 2
  '审核不通过', // 3
  '审核中', // 4 通过1审核,进入2审核
  '审核中', // 5 通过2审,进入终审
  '', // 6
  '', // 7
  '', // 8
  '待提交', //9 已完善待提交
  '待完善信息', // 10
  '未认证', //11
];
// 用户存证状态
const VLIAN_STATUS = [
  '尚未存证', //0
  '已存证', //1
  '存证中', //2 正在下载
  '存证中', //3 已下载，正在存证
  '存证失败', //4 下载失败
  '存证失败', //5 存证失败
  '', //6
  '', //7
  '', //8
  '', //9
  '申请存证', //10 用户申请存证
  '不存证', //11 用户申请不存证
];
// 折扣状态 0不可用，1可用，2已使用，3过期，4已取消
const DISCOUNT_COUPON_STATUS = ['不可用', '可使用', '已使用', '已过期', '已取消'];
const searchTypeOption = [
  {
    value: '',
    label: '全部',
  },
  {
    value: '1',
    label: '视频',
  },
  {
    value: '11',
    label: '图片',
  },
  {
    value: '2',
    label: '模板',
  },
];

const TYPE_OPTIONS = [
  {
    value: 1,
    label: '视频素材',
  },
  {
    value: 2,
    label: '模板素材',
  },
  {
    value: 11,
    label: '图片素材',
  },
];

const AUTH_LIST = [
  {
    title: '个人交流使用',
    subTitle: '（非法人主体）',
    desc: '个人学习交流、毕业设计、聚会、工作汇报、参赛表演等',
    personAuth: true,
    companyAuth: true,
    companyAuthPlus: true,
    isOnlyPerson: true,
  },
  {
    title: '个人自媒体平台',
    subTitle: '（非法人主体）',
    desc: '公众号、微博、头条号、抖音、B站等其它自媒体平台短视频、直播等',
    personAuth: true,
    companyAuth: true,
    companyAuthPlus: true,
    isOnlyPerson: true,
  },
  {
    title: '企业官方广告宣传',
    desc: '企业内部或官网展示、企业新媒体渠道、线下门店等推广视频',
    personAuth: false,
    companyAuth: true,
    companyAuthPlus: true,
  },
  {
    title: '赛事、演出、会议等现场活动',
    personAuth: false,
    companyAuth: true,
    companyAuthPlus: true,
    desc: '商场、赛事、会议、演出、展会等现场活动演播',
  },
  {
    title: '电商平台',
    desc: '淘宝、天猫、京东等线上店铺展示',
    personAuth: false,
    companyAuth: true,
    companyAuthPlus: true,
  },
  {
    title: '经营场所',
    personAuth: false,
    companyAuth: true,
    companyAuthPlus: true,
    desc: '经营场所的现场视频播放',
  },
  {
    title: '线上线下广告投放',
    personAuth: false,
    companyAuth: true,
    companyAuthPlus: true,
    desc: '户外、地铁、楼宇电梯广告；线上广告、社交网络、移动设备广告等',
  },
  {
    title: '游戏/APP等产品内部内容',
    personAuth: false,
    companyAuth: false,
    companyAuthPlus: true,
    desc: '游戏内部内容 、软件及硬件产品内的视频',
  },
  {
    title: '电影/电视/TVC',
    personAuth: false,
    companyAuth: false,
    companyAuthPlus: true,
    desc: '电影、综艺、纪录片、电视剧等影视作品或栏目',
  },
];
const serveOption = [
  { value: 1, label: '著作权登记' },
  { value: 2, label: '与著作权有关权力事项登记' },
];
const attributOption = [
  { value: 'oneself', label: '个人作品' },
  { value: 'teamwork', label: '合作作品' },
  { value: 'legal_person', label: '法人作品' },
  { value: 'job', label: '职务作品' },
  { value: 'entrust', label: '委托作品' },
];
const takeOutOption = [
  { value: 'original', label: '原始' },
  { value: 'obtain', label: '继承' },
  { value: 'bear', label: '承受' },
  { value: 'other', label: '其他' },
];
const receiveOption = [
  { value: '电子证书', label: '电子证书' },
  // { value: '快递邮寄', label: '电子+纸质证书', disabled: true },
];
// const workOption = [
//   { value: '文字作品', label: '文字作品' },
//   { value: '口述作品', label: '口述作品' },
//   { value: '音乐作品', label: '音乐作品' },
//   { value: '戏剧作品', label: '戏剧作品' },
//   { value: '曲艺作品', label: '曲艺作品' },
//   { value: '舞蹈作品', label: '舞蹈作品' },
//   { value: '杂技艺术作品', label: '杂技艺术作品' },
//   { value: '美术作品', label: '美术作品' },
//   { value: '建筑作品', label: '建筑作品' },
//   { value: '摄影作品', label: '摄影作品' },
//   { value: '电影和类似摄制电影方法创作的作品', label: '电影和类似摄制电影方法创作的作品' },
//   { value: '图形作品', label: '图形作品' },
//   { value: '模型作品', label: '模型作品' },
//   { value: '其他作品', label: '其他作品' },
// ];
const workOption = [
  { value: 2, label: '美术作品' },
  { value: 1, label: '摄影作品' },
  { value: 4, label: '⽂字' },
  { value: 3, label: '类似摄制电影方法制作的作品' },
  { value: 5, label: '⾳乐' },
  { value: 6, label: '⼯程设计图、产品设计图' },
  { value: 8, label: '戏剧' },
  { value: 9, label: '曲艺' },
  { value: 10, label: '舞蹈' },
  { value: 11, label: '杂技艺术' },
  { value: 12, label: '建筑' },
  { value: 13, label: '模型' },
  { value: 14, label: '地图、示意图' },
  { value: 16, label: '⼝述' },
  { value: 7, label: '其他' },
];
const makeOption = [
  { value: 1, label: '录音制品' },
  { value: 2, label: '录像制品' },
];
const natureOptions = [
  { value: '原创', label: '原创' },
  { value: '改编', label: '改编' },
  { value: '翻译', label: '翻译' },
  { value: '注释', label: '注释' },
  { value: '整理', label: '整理' },
  { value: '汇编', label: '汇编' },
  { value: '其他', label: '其他' },
];
const sampleOption = [
  { value: 1, label: '电子介质' },
  { value: 2, label: '纸介质' },
];
const powerSl = [
  { value: '发表权', label: '发表权' },
  { value: '署名权', label: '署名权' },
  { value: '修改权', label: '修改权' },
  { value: '保护作品完整权', label: '保护作品完整权' },
  { value: '复制权', label: '复制权' },
  { value: '发行权', label: '发行权' },
  { value: '出租权', label: '出租权' },
  { value: '展览权', label: '展览权' },
  { value: '表演权', label: '表演权' },
  { value: '放映权', label: '放映权' },
  { value: '广播权', label: '广播权' },
  { value: '信息网络传播权', label: '信息网络传播权' },
  { value: '摄制权', label: '摄制权' },
  { value: '改编权', label: '改编权' },
  { value: '翻译权', label: '翻译权' },
  { value: '汇编权', label: '汇编权' },
  { value: '其他', label: '其他' },
];
const fileTypeSl = [
  { value: 'TEXT', label: '文本' },
  { value: 'IMAGE', label: '图片' },
  { value: 'AUDIO', label: '音频' },
  { value: 'VIDEO', label: '视频' },
];
const trueOption = [
  { value: 'PASSWORD', label: '密码验证' },
  { value: 'CONFIRM_SMS', label: '用户短信验证' },
  { value: 'LIVE_SMS', label: '指纹或视频人脸验证' },
  { value: 'CERTIFCATE', label: '电子签名验证' },
];
const workNameSl = [
  { value: 'WORD', label: '文字作品' },
  { value: 'ORAL', label: '口述作品' },
  { value: 'MUSIC', label: '音乐作品' },
  { value: 'DRAMA', label: '戏剧作品' },
  { value: 'QUYI', label: '曲艺作品' },
  { value: 'DANCE', label: '舞蹈作品' },
  { value: 'ACRABATICS', label: '杂技艺术作品' },
  { value: 'ART', label: '美术作品' },
  { value: 'ARCHITECTURE', label: '建筑作品' },
  { value: 'PHOTOGRAPHY', label: '摄影作品' },
  { value: 'MOVIE', label: '电影作品' },
  { value: 'AUDIOVISUAL', label: '类似摄制电影方法创作的作品' },
  { value: 'DESIGN', label: '工程设计图' },
  { value: 'MODEL', label: '模型作品' },
  { value: 'DIAGRAM', label: '示意图' },
];
const TIP_CONTENT = [
  {
    value: 'workType',
    label:
      '(1)文字作品，是指小说、诗词、散文、论文等以文字形式表现的作品；(2)口述作品，是指即兴的演说、授课、法庭辩论等以口头语言形式表现的作品；(3)音乐作品，是指歌曲、交响乐等能够演唱或者演奏的带词或者不带词的作品；(4)戏剧作品，是指话剧、歌剧、地方戏等供舞台演出的作品；(5)曲艺作品，是指相声、快书、大鼓、评书等以说唱为主要形式表演的作品；(6)舞蹈作品，是指通过连续的动作、姿势、表情等表现思想、情感的作品；(7)杂技艺术作品，是指杂技、魔术、马戏等通过形体动作和技巧表现的作品；(8)美术作品，是指绘画、书法、雕塑等以线条、色彩或者其他方式构成的有审美意义的平面或者立体的造型艺术作品；(9)建筑作品，是指以建筑物或者构筑物形式表现的有审美意义的作品；(10)摄影作品，是指借助器械在感光材料或者其他介质上记录客观物体形象的艺术作品；(11)电影作品和以类似摄制电影的方法创作的作品，是指摄制在一定介质上，由一系列有伴音或者无伴音的画面组成，并且借助适当装置放映或者以其他方式传播的作品；(12)图形作品，是指为施工、生产绘制的工程设计图、产品设计图，以及反映地理现象、说明事物原理或者结构的地图、示意图等作品；(13)模型作品，是指为展示、试验或者观测等用途，根据物体的形状和结构，按照一定比例制成的立体作品。',
  },
  {
    value: 'workDate',
    label:
      '1.录音制品：填写该制品首次制作完成的日期，写明年、月、日；2.录像制品：填写该制品首次制作完成的日期，写明年、月、日；3.表演：填写该表演发生的日期，写明年、月、日；4.版式设计：填写使用该版式设计的图书、期刊首次出版的日期，写明年、月、日；5.广播：填写该广播首次播放的日期，写明年、月、日；6.电视：填写该电视首次播放的日期，写明年、月、日。',
  },
  {
    value: 'belongWay',
    label:
      '1.个人作品：作品由作者创作，代表作者意志，并由作者承担责任的作品，作者与著作权人皆为自然人；2.法人作品：法人（或其他组织）主持，代表法人（或其他组织）意志创作，并由法人（或其他组织）承担责任的作品，作者与著作权人皆为法人（或其他组织）；3.职务作品：创作者为完成法人（或其他组织）工作任务所创作的作品，作者为创作者，著作权（视实际情况）归属作者或法人；4.委托作品：创作者受委托而创作的作品，作者为创作者，著作权归属根据委托合同而定；5.合作作品：两人以上合作创作的作品，作者为合作作者，著作权亦归属合作作者',
  },
  {
    value: 'getType',
    label: '(1)作品著作权人即为作者，则选择原始取得；(2)通过合法途径取得作品著作权，则选择承受取得；(3)通过继承的方式取得作品著作权，则选择继承取得。',
  },
];

const QQ_WJ_LINK = 'https://wj.qq.com/s2/10551324/185c/';

// 0|普通发票 1|专业发票 2|增值税专用发票
const invoicesType = [
  { label: '增值税普通发票', value: 0 },
  // { label: '专业发票', value: 1 },
  { label: '增值税专用发票', value: 2 },
];
const invoicesTaxSelectOptions = [
  { label: '6%', value: 6 },
  { label: '3%', value: 3 },
  { label: '1%', value: 1 },
  { label: '免税', value: 0 },
];

// const  = [
//   { value: 'original', label: '原始' },
//   { value: 'obtain', label: '继受' },
// ];
const belongingSelectOpt = [
  { value: 'oneself', label: '个人作品' },
  { value: 'legal_person', label: '法人作品' },
  { value: 'job', label: '职务作品' },
  { value: 'entrust', label: '委托作品' },
  { value: 'teamwork', label: '合作作品' },
];
const belongingSelectOptGuoban = [
  { value: 'oneself', label: '个人作品' },
  { value: 'legal_person', label: '法人作品' },
];

const monitorVideoDurTypeOpt = [
  { label: '短视频（10分钟以内）', value: 'VIDEO_SHORT' },
  { label: '中视频（10分钟-30分钟）', value: 'VIDEO_MIDDLE' },
  { label: '长视频（30分钟以上）', value: 'VIDEO_LONG' },
];
// const certificateOptions = [
// { value: 'ID_CARD', label: '居民身份证' },
// { value: 'BUSINESS_LICENSE', label: '营业执照' },
// { value: 'ORGANIZATION', label: '组织机构代码证' },
// { value: 'UNIFIED_SOCIAL', label: '统一社会信用代码证书' },
// { value: 'ACCOUNT_BOOK', label: '其他证件(户口本)' },
// { value: 'OTHER', label: '其他证书' },
// ];
const certificateOptions = {
  PERSONAL: [
    { value: 'ID_CARD', label: '居民身份证' },
    { value: 'ACCOUNT_BOOK', label: '其他证件(户口本)' },
  ],
  ORGANISATIONS: [{ value: 'BUSINESS_LICENSE', label: '营业执照' }],
  NONORGANISATIONS: [
    { value: 'ORGANIZATION', label: '组织机构代码证' },
    { value: 'UNIFIED_SOCIAL', label: '统一社会信用代码证书' },
    { value: 'OTHER', label: '其他证书' },
  ],
};
const ownerOptions = [
  { value: 'PERSONAL', label: '个人' },
  { value: 'ORGANISATIONS', label: '企业' },
  // { value: 'NONORGANISATIONS', label: '非企业法人' },
];

const certificateTypeOpt = [
  { value: 1, label: '个人' },
  { value: 2, label: '机构' },
];
const cyFirstType = [
  { value: 'PAPER', label: '版权纸质存证' },
  { value: 'REGISTER', label: '版权登记' },
  { value: 'MONITOR', label: '版权监测' },
  { value: 'CRE', label: '版权存证' },
  { value: 'NOTARIZATION', label: '数字公证' },
];
// const PLAN_SERVE_STATUS_TEXT = ['草稿', '待审核', '审核拒绝', '审核通过'];

const workOptionGB = [
  {
    value: 2,
    label: '美术作品',
    maxSize: 5 * 1024 * 1024,
    tips: '支持JPG、PNG、JPEG；大小不超过5M；图片像素不低于400*400，不高于5000*5000；只能上传1张',
    accept: '.jpg,.png,.jpeg',
    maxCount: 1,
  },
  { value: 4, label: '⽂字作品', maxSize: 10 * 1024 * 1024, tips: '支持PDF ；大小不超过10M；只能上传1个', accept: '.pdf', maxCount: 1 },
  { value: 16, label: '⼝述作品', maxSize: 50 * 1024 * 1024, tips: '支持MP3、WAV；大小不超过50M；只能上传1个', accept: '.jpg,.png,.jpeg', maxCount: 1 },
  { value: 5, label: '⾳乐作品', maxSize: 50 * 1024 * 1024, tips: '支持MP3、WAV；大小不超过50M；只能上传1个', accept: '.mp3,.wav', maxCount: 1 },
  { value: 8, label: '戏剧作品', maxSize: 10 * 1024 * 1024, tips: '支持PDF ；大小不超过10M；只能上传1个', accept: '.pdf', maxCount: 1 },
  { value: 9, label: '曲艺作品', maxSize: 10 * 1024 * 1024, tips: '支持PDF ；大小不超过10M；只能上传1个', accept: '.pdf', maxCount: 1 },
  {
    value: 11,
    label: '杂技作品',
    maxSize: 200 * 1024 * 1024,
    tips: '支持MP4、AVI、WMV ；大小不超过200M；视频长度不小于10s；只能上传1个',
    accept: '.mp4,.avi,.wmv',
    maxCount: 1,
  },
  {
    value: 12,
    label: '建筑作品',
    maxSize: 5 * 1024 * 1024,
    tips: '支持JPG、PNG、JPEG；大小不超过5M；图片像素不低于400*400，不高于5000*5000；只能上传1张',
    accept: '.jpg,.png,.jpeg',
    maxCount: 1,
  },
  {
    value: 1,
    label: '摄影作品',
    maxSize: 5 * 1024 * 1024,
    tips: '支持JPG、PNG、JPEG；大小不超过5M；图片像素不低于400*400，不高于5000*5000；只能上传1张',
    accept: '.jpg,.png,.jpeg',
    maxCount: 1,
  },
  {
    value: 10,
    label: '舞蹈作品',
    maxSize: 200 * 1024 * 1024,
    tips: '支持MP4、AVI、WMV ；大小不超过200M；视频长度不小于10s；只能上传1个',
    accept: '.mp4,.avi,.wmv',
    maxCount: 1,
  },
  {
    value: 17,
    label: '电影作品',
    maxSize: 200 * 1024 * 1024,
    tips: '支持MP4、AVI、WMV ；大小不超过200M；视频长度不小于10s；只能上传1个',
    accept: '.mp4,.avi,.wmv',
    maxCount: 1,
  },
  {
    value: 3,
    label: '类似摄制电影方法创作作品',
    maxSize: 200 * 1024 * 1024,
    tips: '支持MP4、AVI、WMV ；大小不超过200M；视频长度不小于10s；只能上传1个',
    accept: '.mp4,.avi,.wmv',
    maxCount: 1,
  },
  {
    value: 6,
    label: '⼯程设计图、产品设计图',
    maxSize: 5 * 1024 * 1024,
    tips: '支持JPG、PNG、JPEG；大小不超过5M；图片像素不低于400*400，不高于5000*5000；只能上传1张',
    accept: '.jpg,.png,.jpeg',
    maxCount: 1,
  },
  {
    value: 13,
    label: '模型',
    maxSize: 5 * 1024 * 1024,
    tips: '支持JPG、PNG、JPEG；大小不超过5M；图片像素不低于400*400，不高于5000*5000；只能上传1张',
    accept: '.jpg,.png,.jpeg',
    maxCount: 1,
  },
  {
    value: 14,
    label: '示意图',
    maxSize: 5 * 1024 * 1024,
    tips: '支持JPG、PNG、JPEG；大小不超过5M；图片像素不低于400*400，不高于5000*5000；只能上传1张',
    accept: '.jpg,.png,.jpeg',
    maxCount: 1,
  },
];

const workOptionGS = [
  { value: 2, label: '美术作品', maxSize: 10 * 1024 * 1024, tips: '仅支持jpg|png|jpeg格式,大小10MB以内', accept: '.jpeg,.jpg,.png', maxCount: 6 },
  { value: 1, label: '摄影作品', maxSize: 10 * 1024 * 1024, tips: '仅支持jpg|png|jpeg格式,大小10MB以内', accept: '.jpeg,.jpg,.png', maxCount: 6 },
  { value: 11, label: '杂技艺术作品', maxSize: 50 * 1024 * 1024, tips: '仅支持mp4格式,大小50MB以内', accept: '.mp4', maxCount: 1 },
  { value: 12, label: '建筑作品', maxSize: 50 * 1024 * 1024, tips: '仅支持jpg|png|jpeg格式,大小10MB以内', accept: '.jpeg,.jpg,.png', maxCount: 1 },
  { value: 10, label: '舞蹈作品', maxSize: 50 * 1024 * 1024, tips: '仅支持mp4格式,大小50MB以内', accept: '.mp4', maxCount: 1 },
  { value: 8, label: '戏剧作品', maxSize: 50 * 1024 * 1024, tips: '仅支持mp4格式,大小50MB以内', accept: '.mp4', maxCount: 1 },
  { value: 14, label: '地图,示意图', maxSize: 10 * 1024 * 1024, tips: '仅支持jpg|png|jpeg格式,大小10MB以内', accept: '.jpeg,.jpg,.png', maxCount: 1 },
  { value: 3, label: '视听作品', maxSize: 50 * 1024 * 1024, tips: '仅支持mp4格式,大小50MB以内', accept: '.mp4', maxCount: 1 },
  { value: 13, label: '模型作品', maxSize: 50 * 1024 * 1024, tips: '仅支持jpg|png|jpeg格式,大小10MB以内', accept: '.jpeg,.jpg,.png', maxCount: 1 },
  { value: 5, label: '⾳乐作品', maxSize: 50 * 1024 * 1024, tips: '仅支持mp3|jpg|pdf|mp4格式,大小50MB以内', accept: '.mp3,.jpg,.pdf,.mp4', maxCount: 1 },
  {
    value: 7,
    label: '其他作品',
    maxSize: 10 * 1024 * 1024,
    tips: '其他仅支持jpg|png|jpeg|mp4|pdf|doc|docx|txt|wav|mp3|wma|acc格式,大小10MB以内。',
    accept: '.jpg,.png,.jpeg,.mp4,.pdf,.doc,.docx,.txt,.wav,.mp3,.wma,.acc',
    maxCount: 1,
  },
  { value: 6, label: '⼯程设计图,产品设计图', maxSize: 10 * 1024 * 1024, tips: '仅支持jpg|png|jpeg格式,大小10MB以内', accept: '.jpeg,.jpg,.png', maxCount: 1 },
  {
    value: 9,
    label: '曲艺作品',
    maxSize: 50 * 1024 * 1024,
    tips: '仅支持wav|mp3|wma|acc|mp4|doc|docx|pdf格式,大小50MB以内',
    accept: '.wav,.mp3,.wma,.acc,.mp4,.doc,.docx,.pdf',
    maxCount: 1,
  },
  {
    value: 101,
    label: '录音制品',
    maxSize: 50 * 1024 * 1024,
    tips: '仅支持wav|mp3|wma|acc|mp4|doc|docx|pdf格式,大小50MB以内',
    accept: '.wav,.mp3,.wma,.acc,.mp4,.doc,.docx,.pdf',
    maxCount: 1,
  },
  {
    value: 16,
    label: '⼝述作品',
    maxSize: 50 * 1024 * 1024,
    tips: '仅支持wav|mp3|wma|acc|mp4|doc|docx|pdf格式,大小50MB以内',
    accept: '.wav,.mp3,.wma,.acc,.mp4,.doc,.docx,.pdf',
    maxCount: 1,
  },
  { value: 4, label: '⽂字作品', maxSize: 50 * 1024 * 1024, tips: '仅支持pdf|doc|docx|txt格式,大小50MB以内', accept: '.pdf,.doc,.docx', maxCount: 1 },
  { value: 100, label: '录像制品', maxSize: 50 * 1024 * 1024, tips: '录像制品仅支持mp4格式,大小50MB以内。', accept: '.mp4', maxCount: 1 },
];

const workOptionSD = [
  { value: 1, label: '摄影作品', maxSize: 4 * 1024 * 1024, tips: '请上传JPG、PNG格式,文件大小4M以内', accept: '.jpg,.png', maxCount: 6 },
  { value: 2, label: '美术作品', maxSize: 4 * 1024 * 1024, tips: '请上传JPG、PNG格式,文件大小4M以内', accept: '.jpg,.png', maxCount: 6 },
  { value: 3, label: '类似摄制电影方法制作的作品', maxSize: 4 * 1024 * 1024, tips: '请上传MP4格式的视频，文件大小50M以内', accept: '.mp4,.MP4', maxCount: 1 },
  { value: 4, label: '⽂字', maxSize: 50 * 1024 * 1024, tips: '请上传PDF格式,文件大小50M以内', accept: '.pdf,.PDF', maxCount: 1 },
  { value: 5, label: '⾳乐', maxSize: 50 * 1024 * 1024, tips: '请上传MP3格式50M以内，和JPG格式，PNG格式4M以内', accept: '.mp3,.jpg,.png', maxCount: 1 },
  {
    value: 6,
    label: '⼯程设计图、产品设计图',
    maxSize: 50 * 1024 * 1024,
    tips: '请上传PDF格式50M以内或JPG格式，PNG格式文件大小4M以内',
    accept: '.pdf,.jpg,.png',
    maxCount: 1,
  },
  { value: 8, label: '戏剧', maxSize: 50 * 1024 * 1024, tips: '请上传PDF格式或MP4格式,文件大小50M以内', accept: '.pdf,.mp4', maxCount: 1 },
  { value: 9, label: '曲艺', maxSize: 50 * 1024 * 1024, tips: '请上传PDF格式或MP4格式,文件大小50M以内', accept: '.pdf,.mp4', maxCount: 1 },
  { value: 10, label: '舞蹈', maxSize: 50 * 1024 * 1024, tips: '请上传PDF格式或MP4格式,文件大小50M以内', accept: '.pdf,.mp4', maxCount: 1 },
  { value: 11, label: '杂技艺术', maxSize: 50 * 1024 * 1024, tips: '请上传PDF格式或MP4格式,文件大小50M以内', accept: '.pdf,.mp4', maxCount: 1 },
  { value: 12, label: '建筑', maxSize: 50 * 1024 * 1024, tips: '请上传PDF格式50M以内或JPG格式，PNG格式文件大小4M以内', accept: '.pdf,.jpg,.png', maxCount: 1 },
  { value: 13, label: '模型', maxSize: 50 * 1024 * 1024, tips: '请上传PDF格式50M以内或JPG格式，PNG格式文件大小4M以内', accept: '.pdf,.jpg,.png', maxCount: 1 },
  {
    value: 14,
    label: '地图、示意图',
    maxSize: 50 * 1024 * 1024,
    tips: '请上传PDF格式50M以内或JPG格式，PNG格式文件大小4M以内',
    accept: '.pdf,.jpg,.png',
    maxCount: 1,
  },
  { value: 16, label: '⼝述', maxSize: 50 * 1024 * 1024, tips: '请上传MP3格式的音频,文件大小50M以内', accept: '.mp3', maxCount: 1 },
  { value: 7, label: '其他', maxSize: 50 * 1024 * 1024, tips: '请上传PDF格式50M以内或JPG格式，PNG格式文件大小4M以内', accept: '.pdf,.jpg,.png', maxCount: 1 },
];
export {
  searchTypeOption,
  TYPE_OPTIONS,
  AUTH_LIST,
  WORK_STATUS_TEXT,
  VLIAN_STATUS,
  DISCOUNT_COUPON_STATUS,
  serveOption,
  attributOption,
  sampleOption,
  natureOptions,
  makeOption,
  workOption,
  receiveOption,
  takeOutOption,
  TIP_CONTENT,
  powerSl,
  fileTypeSl,
  trueOption,
  QQ_WJ_LINK,
  invoicesType,
  invoicesTaxSelectOptions,
  workNameSl,
  belongingSelectOpt,
  belongingSelectOptGuoban,
  monitorVideoDurTypeOpt,
  certificateOptions,
  ownerOptions,
  certificateTypeOpt,
  cyFirstType,
  workOptionGB,
  workOptionGS,
  workOptionSD,
  // PLAN_SERVE_STATUS_TEXT,
};

// 存证相关type
// CRE:版权存证价格
// CRE_REGISTER:版权登记一般价格
// CRE_REGISTER_10:版权登记加急
// CRE_REGISTER_3:版权登记特急
// CRE_REGISTER_CANCEL:撤销版权登记
// CRE_REGISTER_PRINT:证书打印
// CRE_REGISTER_REPLACE:补办证书
// FORENSICS:取证价格
// APR_MONITOR:电商监测价格
// IMG_MONITOR:图片监测价格
// PTT_MONITOR:肖像监测价格
